/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IVinhusetProductSpecificationTabData } from './vinhuset-product-specification-tab.data';
import { IVinhusetProductSpecificationTabProps } from './vinhuset-product-specification-tab.props.autogenerated';

export interface IVinhusetProductSpecificationTabViewProps extends IVinhusetProductSpecificationTabProps<IVinhusetProductSpecificationTabData> {}

/**
 *
 * VinhusetProductSpecificationTab component
 * @extends {React.PureComponent<IVinhusetProductSpecificationTabProps<IVinhusetProductSpecificationTabData>>}
 */
class VinhusetProductSpecificationTab extends React.PureComponent<IVinhusetProductSpecificationTabProps<IVinhusetProductSpecificationTabData>> {
    public render(): JSX.Element | null {
        const { typeName, id, slots } = this.props;

        return (
            <div className={`${typeName} ${id}`}>
                {slots &&
                    slots.content &&
                    slots.content.map((children: React.ReactNode, index: number) => {
                        return (
                            <div className={'col-12'} key={index}>
                                {children}
                            </div>
                        );
                    })}
            </div>
        );
    }
}

export default VinhusetProductSpecificationTab;
